module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sidebar2"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "ch01sub4"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("BASIC RHYTHMS")])])]), _c('a', {
    attrs: {
      "id": "ch01sub4"
    }
  }), _c('h2', {
    staticClass: "h2tit"
  }, [_c('a', {
    attrs: {
      "id": "ch01sub4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("You Have to Start Somewhere")])])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("In music, changing the appearance of the notes indicates the rhythm. Remember, the location of the notes is fixed on the staff and will never change. However, the note’s appearance varies, indicating how long that note should be held. Now, here are the basic musical symbols for rhythm.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("QUARTER NOTES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A quarter note ("), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/com-02.jpg"
    }
  }), _vm._v(") is signified with a filled-in black circle (also called a notehead) and a stem. It is the simplest rhythm to discuss. Quarter notes receive one count; their duration is one beat (see the following figure).")]), _vm._v(" "), _c('div', {
    staticClass: "inline_group"
  }, [_c('img', {
    staticClass: "landscape_50",
    attrs: {
      "alt": "image",
      "src": "images/f0020-01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("HALF NOTES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The next in our series of simple rhythms is the half note ("), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/rb.jpg"
    }
  }), _vm._v("). As you can see, the half note looks similar to the quarter note, except the circle is not filled in. Like a quarter note, the half note has a single stem that points either up or down. The half note receives two counts; its duration is two beats. In relation to the quarter note, the half note is twice as long because it receives two counts (see the next figure).")]), _vm._v(" "), _c('div', {
    staticClass: "inline_group"
  }, [_c('img', {
    staticClass: "landscape_50",
    attrs: {
      "alt": "image",
      "src": "images/f0020-02.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("WHOLE NOTES")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("A whole note ("), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/o.jpg"
    }
  }), _vm._v(") is a rhythm that receives four beats. It’s twice as long as a half note and four times as long as a quarter note—count to yourself: one, two, three, four. A whole note is represented as an open circle without a stem. It is probably the single longest rhythmic value that you will come across. Whole notes are easy to spot because they are the only notes that lack a stem (see the following figure).")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('div', {
    staticClass: "inline_group"
  }, [_c('img', {
    staticClass: "landscape_50",
    attrs: {
      "alt": "image",
      "src": "images/f0021-01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("EIGHTH NOTES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The smallest rhythm you have encountered thus far is the quarter note, which lasts for one beat. Dividing this beat further allows musicians to explore faster rhythms and faster passages. Chopping the quarter note in half gives us the eighth note ("), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/com-04.jpg"
    }
  }), _vm._v("), which receives half of one beat (see the next figure).")]), _vm._v(" "), _c('div', {
    staticClass: "inline_group"
  }, [_c('img', {
    staticClass: "landscape_50",
    attrs: {
      "alt": "image",
      "src": "images/f0021-02.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("SIXTEENTH NOTES")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("The beat can be broken down even further for the faster note values. The next rhythm is the sixteenth note ("), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/com-03.jpg"
    }
  }), _vm._v("), which breaks the quarter note into four equal parts and the eighth note into two equal parts (see the following figure).")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('div', {
    staticClass: "inline_group"
  }, [_c('img', {
    staticClass: "landscape_50",
    attrs: {
      "alt": "image",
      "src": "images/f0022-01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("FASTER NOTE VALUES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s possible to keep chopping the beat into smaller and smaller parts. The next step beyond sixteenth notes is the thirty-second note, which breaks one beat into eight equal parts. Just like the transition from eighth to sixteenth notes, going from sixteenth to thirty-second notes will add another flag or beam to the notes. Add another flag and it will simply make the note value half the length of the previous note. The next figure shows faster note values.")]), _vm._v(" "), _c('div', {
    staticClass: "inline_group"
  }, [_c('img', {
    staticClass: "landscape_100",
    attrs: {
      "alt": "image",
      "src": "images/f0022-02.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("AUGMENTATION DOTS")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("You have focused on making note values smaller and smaller, but you can also make them larger by using an augmentation dot. Placing a small dot directly to the right of any note increases its duration by one-half. For example, placing a dot after a half note makes the dotted half last for three beats. The original half note receives two beats and the dot adds half the value of the original note (a half note): The dot adds one extra beat (a quarter note), bringing the total up to three beats. Any note can be dotted. The following figure is a chart of dotted rhythms and their duration.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('div', {
    staticClass: "inline_group"
  }, [_c('img', {
    staticClass: "portrait_60",
    attrs: {
      "alt": "image",
      "src": "images/f0023-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "boxhead"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Notable")])]), _vm._v(" "), _c('hr', {
    staticClass: "hr1"
  }), _vm._v(" "), _c('p', {
    staticClass: "boxtxt"
  }, [_vm._v("A dot extends the value of a note. A tie also extends notes. Both do the same thing, but visually, they do it differently. A dot added to a note requires that you figure out what half of the note value is and count it. A tie is sometimes easier to read because the notes are visually glued together.")]), _vm._v(" "), _c('hr', {
    staticClass: "hr2"
  }), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("TUPLETS")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Up to this point, rhythms have been based on equal divisions of two. For example, breaking a whole note in half results in two half notes. In the same way, dividing a half note in two results in two quarter notes. As the divisions get smaller, going through eighth and sixteenth notes, the notes are continuously broken in half equally. However, beats can also be broken into other groupings—most importantly, groupings based on odd numbers such as three. Such odd groupings are commonly referred to as tuplets.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("When you break a beat into three parts, you give birth to a triplet. The most basic triplet is the eighth-note triplet. An eighth-note triplet is simply three eighth notes that equally divide one beat into three parts (see the next figure). You could also look at it like a ratio: three notes equally divided in the same space as one beat. Since there are three notes in each beat, eighth-note triplets are faster than two eighth notes taking up the same beat. The more notes per beat, the faster they progress.")]), _vm._v(" "), _c('div', {
    staticClass: "inline_group"
  }, [_c('img', {
    staticClass: "landscape_50",
    attrs: {
      "alt": "image",
      "src": "images/f0024-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Tuplets don’t have to be in threes, although that is the most common tuplet in music. You can have tuplets that divide a beat into any number of parts: five, seven, even eleven. The number above the grouping of notes indicates how it’s supposed to be divided.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("RESTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("All this talk about notes and rhythms wouldn’t be complete without some discussion of rests. Everything you’ve learned about rhythms also applies to rests. The only difference is that a rest tells you not to do anything!")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Every pitch needs duration. Rhythm defines how long notes should be sustained. Music isn’t always about sound—rests are as common as pitches. Rests indicate a spot in the music where you don’t play a sound. Since a rest does not have a pitch associated with it, it requires a different symbol. Here’s a chart of the rests (see the following figure) and their associated notes.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('hr', {
    staticClass: "hr1"
  }), _vm._v(" "), _c('div', {
    staticClass: "inline_group"
  }, [_c('img', {
    staticClass: "portrait_60",
    attrs: {
      "alt": "image",
      "src": "images/f0025-01.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-039580cd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01d.vue
// module id = 84
// module chunks = 0